// extracted by mini-css-extract-plugin
export default {"container":"TrainerForm_container__XfcCz","card":"TrainerForm_card__ppI4E","title":"TrainerForm_title__zFvvo"};